import classes from './FieldsLayout.module.css'
import { Outlet } from 'react-router-dom'
import SideNav from '../components/SideNav'

import { fields } from '../store/store'


export default function FieldsLayout() {
    return (
        <div className={`container ${classes.fields}`}>
            <SideNav data={fields} />
            <Outlet />
        </div>
    )
}
